import env from '../env';

export default function getAppVersion() {
  return env.REACT_APP_VERSION;
}